import React from 'react'
import {
  Typography,
  Grid,
  makeStyles,
} from '@material-ui/core'
import Page from 'src/components/Page'
import ChangePassword from './ChangePassword'

const useStyles = makeStyles(() => ({
  root: {
    padding: 10,
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
}))

const PasswordChangeView = () => {
  const classes = useStyles()

  return (
    <Page
      className={classes.root}
      title="تغییر رمز عبور"
    >
      <Grid container className={classes.root}>
        <Grid item justify="space-between" className={classes.title}>
          <Typography variant="h3" component="h3">تغییر رمزعبور</Typography>
        </Grid>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
          >
            <ChangePassword />
          </Grid>
        </Grid>
      </Grid>
    </Page>
  )
}

export default PasswordChangeView
